
export const AUTH_CONFIG = {
  // Needed for Auth0 (capitalization: ID):
  client_id: '4udd7dra1sk4NIbZLKFJloDBNffT7iha',
  domain: 'elementdebase.auth0.com',
  redirectURI: `${window.location.origin}`
};
